enum TimeScope {
    DAY= 'day',
    WEEK= 'week',
    MONTH= 'month',
    YEAR= 'year'
}

export function GetInstanceDailyTransactionReport(instance_id: number, time_scope: TimeScope, time_scale: number): {data: any}{
    return {data: null};
    // return Cirus.get(`/instance/${instance_id}/report/daily-trans?${params}`);
}
// `time_scope=${this.period[0]}&time_scale=${this.period[1]}`


// getDailyTransactions(instance_id) {
	// 	return Cirus.get(`/instance/${instance_id}/report/daily-trans`);
	// }